const host = 'https://static.paymentiq.io';

const assets = {
  logo: '',
  invertedLogo: '',
  aiqLogo: `${host}/aiq.svg`,
  aiqLogoInverted: `${host}/aiq-mint.svg`,
  smallWhiteLogo: 'https://inkeep.com/images/logos/brand-download/inkeep-icon-core.svg',
  smallLogo: 'https://inkeep.com/images/logos/brand-download/inkeep-icon-core.svg',
};

export default assets;
